import {type PropsWithChildren} from 'react'
import {tv, type VariantProps} from 'tailwind-variants'
import {gridItem} from '~/design-system/foundations'
import {type HgWYSIWYGType} from '../../types'

const orderedListVariants = tv({
  base: 'list-outside ps-[1em] text-text-default  [&_li_+_li]:mt-s2 [&_li_>_ol]:mt-s2',
  variants: {
    nestedLevel: {
      0: 'list-decimal',
      1: 'list-[lower-alpha]',
      2: 'list-[lower-roman]',
    },
    wysiwygType: {
      article: 'tiempos-body-2',
      legal: 'arcadia-body-2',
    },
  },
})

type OrderedListNestedLevel = NonNullable<
  VariantProps<typeof orderedListVariants>['nestedLevel']
>
export type OrderedListProps = PropsWithChildren<{
  className?: string
  nestedLevel: OrderedListNestedLevel
  wysiwygType: HgWYSIWYGType
}>

export const OrderedList = ({
  children,
  className,
  nestedLevel,
  wysiwygType,
}: OrderedListProps) => {
  return (
    <ol className={orderedListVariants({nestedLevel, className, wysiwygType})}>
      {children}
    </ol>
  )
}

export const HgWYSIWYGOrderedList = ({
  nestedLevel,
  className,
  ...props
}: OrderedListProps) => {
  return (
    <OrderedList
      {...props}
      nestedLevel={nestedLevel || 0}
      className={gridItem({size: 'heading', className})}
    />
  )
}
